import { myPageMaps } from '../myPageMaps';
import type { MyInfoMenu } from '../types';

// 내 정보
const myInfoMenus: MyInfoMenu[] = [
  {
    title: myPageMaps.index.title,
    path: myPageMaps.index.path,
    display: myPageMaps.index.display,
  },
];

export default myInfoMenus;
